import styled from 'styled-components';
import LinearProgress from '@mui/material/LinearProgress';

export const Container = styled.div`
    padding: 1rem;
`;

export const Div = styled.div`
    display: flex;
    width: 100%;
    justify-content: space-between;
    align-items: flex-end;
`;

export const Progress = styled(LinearProgress)`
    height: 8px;
    border-radius: 5px;
    background-color: #dfe2e6 !important;

    .MuiLinearProgress-bar {
        background-color: ${({ value }) => (value < 20 ? '#D35E4B' : value < 50 ? '#F6C619' : '#62C054')} !important;
        border-radius: 5px;
    }
`;
